//import { logger } from "../../../api/Logger";
import { GetCardType } from "../../../api/helpers/cardhelper";
import { DateTime } from "luxon";
import {
  isTimestampAfterDate,
  getDayOfWeekSurcharge,
} from "../../../api/helpers/datetimeHelper";
import {
  calcTotalPrice,
  calSurchargeAmount,
  calSurchargePercentage,
  calSurchargeTax,
} from "../../../api/helpers/shoppingCartHelper";
import uuid from "uuid/v1";
import { fix2digit } from "../../../api/payment/Utilities";
import { validOrderSourceType } from "../../../api/helpers/commonHelpers";
export default {
  state: {
    cardType: "",
    //delivery or pickup time
    dpTime: null,
  },
  mutations: {
    setCardNumber(state, payload) {
      state.cardType = payload;
    },
    setSurchargeTime(state, payload) {
      state.dpTime = payload;
    },
  },
  actions: {
    setCardNumber(context, payload) {
      switch (typeof payload) {
        case "object":
          payload = payload.CardType ? payload.CardType.toLowerCase() : "";
          break;

        case "string":
          payload = GetCardType(payload)
            ? GetCardType(payload).toLowerCase()
            : "";
          break;
      }
      context.commit("setCardNumber", payload);
    },
    clearCardType(context) {
      context.commit("setCardNumber", null);
    },
  },
  getters: {
    getCartType(state) {
      return state.cardType;
    },
    getSurchargeBankValid: (state, getters) => (totalPrice) => {
      let surchargeB = [];
      // if (state.cardType) {
      if (
        getters.selectedCompany &&
        getters.selectedCompany.SurchargeBankSettings &&
        (!getters.selectedCompany.ViewComponentConfigs ||
          !getters.selectedCompany.ViewComponentConfigs.PayLaterOnly)
      ) {
        // if (getters.selectedCompany.IsAllCardSurchargeEnabled) {
        surchargeB = getters.selectedCompany.SurchargeBankSettings.filter(
          (x) =>
            x.CreditCard == "5" &&
            (!x.AmountMinimum || totalPrice >= x.AmountMinimum) &&
            (totalPrice <= x.AmountMaximum ||
              !x.AmountMaximum ||
              x.AmountMaximum == 0) && validOrderSourceType(x.OrderSourceType)
        );
        // } else if (getters.selectedCompany.IsCardTypeSurchargeEnabled) {
        //   surchargeB = getters.selectedCompany.SurchargeBankSettings.filter(
        //     (x) =>
        //       x.CreditCard == mapToNumber(state.cardType) &&
        //       (!x.AmountMinimum || totalPrice >= x.AmountMinimum) &&
        //       (totalPrice <= x.AmountMaximum ||
        //         !x.AmountMaximum ||
        //         x.AmountMaximum == 0)
        //   );
        // }
      }
      // }
      return surchargeB;
    },
    getSurchargeHolidayValid: (state, getters) => (totalPrice) => {
      let surchargeH = [];
      var dTime = DateTime.local();
      if (state.dpTime && !getters.isGift) {
        dTime = DateTime.fromISO(state.dpTime);
      }
      if (
        getters.selectedCompany.SurchargeHolidaySettings &&
        getters.selectedCompany.IsGeneralSurchargeEnabled &&
        (!getters.selectedCompany.ViewComponentConfigs ||
          !getters.selectedCompany.ViewComponentConfigs.PayLaterOnly)
      )
        surchargeH = getters.selectedCompany.SurchargeHolidaySettings.filter(
          (x) => {
            return (
              (!x.AmountMinimum || totalPrice >= x.AmountMinimum) &&
              (totalPrice <= x.AmountMaximum ||
                !x.AmountMaximum ||
                x.AmountMaximum == 0) &&
              ((!x.DayOfWeek && parseInt(x.DayOfWeek) !== 0) ||
                x.DayOfWeek == getDayOfWeekSurcharge(dTime)) &&
              (!x.StartDate ||
                !isTimestampAfterDate(
                  dTime,
                  x.StartDate.seconds,
                  getters.selectedCompany.TimezoneIanaFormat
                )) &&
              (!x.EndDate ||
                isTimestampAfterDate(
                  dTime,
                  x.EndDate.seconds,
                  getters.selectedCompany.TimezoneIanaFormat
                )) &&
              (!x.GuestCountMaximum || x.GuestCountMaximum === 0) &&
              (!x.GuestCountMinimum || x.GuestCountMinimum === 0) &&
              validOrderSourceType(x.OrderSourceType)
            );
          }
        );
      return surchargeH;
    },
    getSurchareHolidayName: (state, getters) => {
      let totalPrice = calcTotalPrice(
        getters.cartValue,
        getters.deliveryFee,
        getters.discount
      );
      let s = getters.getSurchargeHolidayValid(totalPrice);
      if (s.length > 0) return s[0].Name || "Holiday Surcharge";
      else return null;
    },
    getSurchargeHolidayValidTax(state, getters) {
      let totalPrice = calcTotalPrice(
        getters.cartValue,
        getters.deliveryFee,
        getters.discount
      );
      let tax = 0;
      getters.getSurchargeHolidayValid(totalPrice).map((elem) => {
        tax += calSurchargeTax(elem, totalPrice);
      });
      return fix2digit(tax);
    },
    getSurchargeHolidayValidGST(state, getters) {
      const tax = getters.getSurchargeHolidayAmount ? getters.getSurchargeHolidayAmount / 11 : 0;
      return fix2digit(tax);
    },
    getBankSurchargeValidGST(state, getters) {
      const tax = getters.getSurchargeBankAmount ? getters.getSurchargeBankAmount / 11 : 0
      return fix2digit(tax);
    },
    getGiftSurchargeHolidayValidTax(state, getters) {
      let totalPrice = calcTotalPrice(
        getters.giftCartValue,
        0,
        getters.giftDiscount
      );
      let tax = 0;
      getters.getSurchargeHolidayValid(totalPrice).map((elem) => {
        tax += calSurchargeTax(elem, totalPrice);
      });
      return fix2digit(tax);
    },
    getSurchargeBankPercentage: (state, getters) => (includeDeliveryFee = true) => {
      let output = 0;

      if (getters.cartItems && getters.cartItems.length > 0) {
        let totalPrice = calcTotalPrice(
          getters.cartValue,
          includeDeliveryFee ? getters.deliveryFee : 0,
          getters.discount,
          getters.getSurchargeHolidayAmount
        );
        getters.getSurchargeBankValid(totalPrice).map((elem) => {
          const percentage = calSurchargePercentage(elem);
          if(percentage === null) {
            return percentage;
          } else {
            output += percentage;
          }
        });
      }

      return output;
    },
    getSurchargeBankAmount: (state, getters) => (includeDeliveryFee = true) => {
      let amount = 0;
      if (getters.cartItems && getters.cartItems.length > 0) {
        let totalPrice = calcTotalPrice(
          getters.cartValue,
          includeDeliveryFee ? getters.deliveryFee : 0,
          getters.discount,
          getters.getSurchargeHolidayAmount
        );
        getters.getSurchargeBankValid(totalPrice).map((elem) => {
          amount += calSurchargeAmount(elem, totalPrice);
        });
      }

      return amount;
    },
    getGiftcardSurchargeBankAmount(state, getters) {
      let amount = 0;
      let totalPrice = calcTotalPrice(
        getters.giftCartValue,
        0,
        getters.giftDiscount,
        0
      );
      getters.getSurchargeBankValid(totalPrice).map((elem) => {
        amount += calSurchargeAmount(elem, totalPrice);
      });
      return amount;
    },
    getSurchargeHolidayPercentage(state, getters) {
      let output = 0;
      if (getters.cartItems && getters.cartItems.length > 0) {
        let totalPrice = calcTotalPrice(
          getters.cartValue,
          getters.deliveryFee,
          getters.discount
        );
        getters.getSurchargeHolidayValid(totalPrice).map((elem) => {
          const percentage = calSurchargePercentage(elem);
          if(percentage === null) {
            return percentage;
          } else {
            output += percentage;
          }
        });
      }
      return output;
    },
    getSurchargeHolidayAmount(state, getters) {
      let amount = 0;
      if (getters.cartItems && getters.cartItems.length > 0) {
        let totalPrice = calcTotalPrice(
          getters.cartValue,
          getters.deliveryFee,
          getters.discount
        );
        getters.getSurchargeHolidayValid(totalPrice).map((elem) => {
          amount += calSurchargeAmount(elem, totalPrice);
        });
      }
      return amount;
    },
    getGiftSurchargeHolidayAmount(state, getters) {
      let amount = 0;
      let totalPrice = calcTotalPrice(
        getters.giftCartValue,
        0,
        getters.giftDiscount
      );
      getters.getSurchargeHolidayValid(totalPrice).map((elem) => {
        amount += calSurchargeAmount(elem, totalPrice);
      });
      return amount;
    },
    getSurchargePercentage: (state, getters) => (includeDeliveryFee) => {
      const bankPercentage = getters.getSurchargeBankPercentage(includeDeliveryFee);
      const holidayPercentage = getters.getSurchargeHolidayPercentage;
      if(bankPercentage === null || holidayPercentage === null) {
        return null;
      } else {
        return bankPercentage + holidayPercentage;
      }
    },
    getSurchargeAmount: (state, getters) => (includeDeliveryFee) => {
      return fix2digit(
        getters.getSurchargeBankAmount(includeDeliveryFee) + getters.getSurchargeHolidayAmount
      );
    },
    getGiftSurchargeAmount: (state, getters) => {
      return fix2digit(getters.getGiftcardSurchargeBankAmount);
    },
    getSurchargeTransactions: (state, getters) => {
      let transaction = [];
      let totalPrice = calcTotalPrice(
        getters.cartValue,
        getters.deliveryFee,
        getters.discount
      );
      getters.getSurchargeHolidayValid(totalPrice).map((elem) => {
        let amount = calSurchargeAmount(elem, totalPrice);
        if (amount > 0)
          transaction.push({
            Amount: amount,
            Surcharge_ID: elem.ID,
            TransactionTime: new Date().toUTCString(),
            UDID: uuid(),
          });
        totalPrice += amount;
      });
      getters.getSurchargeBankValid(totalPrice).map((elem) => {
        let amount = calSurchargeAmount(elem, totalPrice);
        if (amount > 0)
          transaction.push({
            Amount: amount,
            Surcharge_ID: elem.ID,
            TransactionTime: new Date().toUTCString(),
            UDID: uuid(),
          });
      });
      return transaction;
    },
  },
};
